export const AGENT_REASONING_EFFORT_VALUES = [
  'minimal',
  'low',
  'medium',
  'high',
] as const;

export type AgentReasoningEffort = (typeof AGENT_REASONING_EFFORT_VALUES)[number];

export const AGENT_REASONING_EFFORT_LABELS: Record<AgentReasoningEffort, string> = {
  minimal: 'Minimal',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
};